import { Component, Input } from '@angular/core';
import {
	NavController,
    NavParams } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { DatePipe } from '@angular/common';
import { ReportsService } from '../../../../services/reports.service';
import { Judge, JudgeCategory } from '../../../../model/judge';
import { JudgeService } from '../../../../services/judge.service';
import { DateHelperService } from '../../../../services/date-helper';
@Component({
	selector: 'page-individual-show-report',
	templateUrl: 'report-individual-show.html'
	
})
export class IndividualShowReport {
    @Input('rodeo') rodeo: Rodeo;

    schedule: RodeoEventSchedule;

    display: any = {};
    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    searchRider: string;
    searchHorse: string;
    scores: any[];
    searchChangeObservable: any;

    constructor(private nav: NavController, navParams: NavParams, private datePipe: DatePipe, private reportService: ReportsService, private judgeService: JudgeService, public dateHelper: DateHelperService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.display = navParams.get('display');
        this.scores = navParams.get('scores');

        if (!this.display) {  
            this.display = {};          
        }

        this.display.runs = [];

        if (this.rodeo && this.display)
            this.printing = true;

        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        this.filterResults();

        this.documentTitle = this.rodeo.name + " - " + 'Sheets';
        this.dataLoaded = true;
    }

    /*
    getJudges() {
        this.judgeService.getScoresForRodeoEvent(this.rodeo.id, this.selectedRodeoEvent.id)
            .then(judgeConfig => {
                if (judgeConfig && judgeConfig.judges && judgeConfig.judges.length > 0) {
                    const scoreHash = {};

                    this.judgeConfig = judgeConfig;
                    this.judgeConfig.judges.forEach(judge => {
                        const scoresHash = [];
                        judge.scores.forEach(score => {
                            if (!scoresHash[score.runId]) {
                                scoresHash[score.runId] = {
                                    total: score.score,
                                    scores: [score]
                                }
                            } else {
                                scoresHash[score.runId].total += score.score;
                                scoresHash[score.runId].scores.push(score);
                            }

                            // Second hash?
                            if (!scoreHash[score.runId]) {
                                scoreHash[score.runId] = {
                                    totals: {
                                        total: score.score,
                                    }
                                }
                            } else {
                                scoreHash[score.runId].totals.total += score.score;
                            }

                            if (scoreHash[score.runId].totals[score.category]) {
                                scoreHash[score.runId].totals[score.category] += score.score;
                            } else {
                                scoreHash[score.runId].totals[score.category] = score.score;
                            }

                            if (this.selectedRodeoEvent.configuration.runs.timeValue 
                                && this.selectedRodeoEvent.configuration.runs.scoreValue
                                && !scoresHash[score.runId].scores.some(x => x.category == 'Time')) {
                                var judgeTimeScore: any = {};
    
                                judgeTimeScore.category = 'Time';
                                judgeTimeScore.judgeId = judge.id;
                                judgeTimeScore.rodeoEventId = judge.rodeoEventId;
                                judgeTimeScore.runId = score.runId;
                                judgeTimeScore.score = 25 - +this.displayRun.timeDisplayValue;

                                scoresHash[score.runId].total += judgeTimeScore.score;
                                scoresHash[score.runId].scores.push(judgeTimeScore);
                                scoreHash[score.runId].totals.total += judgeTimeScore.score;

                                if (scoreHash[score.runId].totals['Time']) {
                                    scoreHash[score.runId].totals['Time'] += judgeTimeScore.score;
                                } else {
                                    scoreHash[score.runId].totals['Time'] = judgeTimeScore.score;
                                }
                            }
                        });

                        judge.scoresHash = scoresHash;
                    });

                    if (this.selectedRodeoEvent.averageJudgeTotalScores) {
                        Object.keys(scoreHash).forEach(runId => {
                            Object.keys(scoreHash[runId].totals).forEach(key => {
                                if (key == 'total') {
                                    scoreHash[runId].totals.total = scoreHash[runId].totals.total / this.judgeConfig.judges.length;
                                    console.log("scoreHash[runId].totals.total: ", scoreHash[runId].totals.total);
                                }
                            });
                        });
                    }
                    this.judgeConfig.scoresHash = scoreHash;

                    if (this.displayRun && scoreHash[this.displayRun.id]) {
                        this.displayRun.displayValue = scoreHash[this.displayRun.id].totals.total;                        
                    } else {
                        this.displayRun.displayFieldOne = '';
                    }
                } else {
                    this.judgeConfig = null;
                }
            });
    }
*/

    getJudgeScore(judge: Judge, category: JudgeCategory, runId: number) {
        const judgeScores = judge.scoresHash ? judge.scoresHash[runId] : null;
        if (judgeScores) {
            const score = judgeScores.scores.find(x => x.category == category.category);
            // console.log({score, judge, category, runId});
            return score ? score.score : 0;
        }
    }
    

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop(); 
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        this.nav.push(IndividualShowReport, {
            rodeo: this.rodeo,
            display: this.display,
            scores: this.scores
        }).then(() => { this.popoverActive = false; });
    }

    onRiderNameSearchChange(searchValue) {
        this.onSearchChange('rider' + searchValue);
    }

    onHorseNameSearchChange(searchValue) {
        this.onSearchChange('horse' + searchValue);
    }

    onSearchChange(searchValue) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(700)
                .distinctUntilChanged()
                .subscribe((text) => {
                    this.filterResults();
                });
        }

        this.searchChangeObservable.next(searchValue);
    }

    filterResults() {
        this.display.runs = [];
        this.display.classes = [];
        var allRuns = [];

        this.rodeo.rodeoEvents.forEach(rodeoEvent => {
            rodeoEvent.schedules.forEach(schedule => {
                this.display.classes[schedule.id] = rodeoEvent;
                allRuns.push(...schedule.runs);
            })
        })

        if (this.searchRider) {
            var firstName = this.searchRider.split(' ')[0];
            var lastName = this.searchRider.split(' ')[1];
            if (firstName && !lastName) {
                this.display.runs.push(...allRuns.filter(x =>
                    (
                        x.contestantOne.firstName.toLowerCase().includes(firstName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.firstName && x.contestantTwo.firstName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                    )
                    || (
                        x.contestantOne.lastName.toLowerCase().includes(firstName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.lastName && x.contestantTwo.lastName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                    )));
            } else {
                this.display.runs.push(...allRuns.filter(x =>
                    (
                        x.contestantOne.firstName.toLowerCase().includes(firstName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.firstName && x.contestantTwo.firstName.toLowerCase().includes(firstName.toLocaleLowerCase()))
                    )
                    && (
                        x.contestantOne.lastName.toLowerCase().includes(lastName.toLocaleLowerCase())
                        || (x.contestantTwo && x.contestantTwo.lastName && x.contestantTwo.lastName.toLowerCase().includes(lastName.toLocaleLowerCase()))
                    )));
            }
        }

        if (this.searchHorse) {
            if (firstName && !lastName) {
                this.display.runs.push(...allRuns.filter(x =>
                    (
                        x.horseOne.name.toLowerCase().includes(this.searchHorse.toLocaleLowerCase())
                        || (x.horseTwo && x.horseTwo.name.toLowerCase().includes(this.searchHorse.toLocaleLowerCase()))
                    )));
            }
        }
    }

    addRunToPrint(run) {
        if (!this.display.judgeData)
            this.display.judgeData = { runs: [], scores: [], errors: []};

        if (this.display.judgeData.runs.includes(run))
            return;

        if (!this.display.judgeData)
            this.display.judgeData = {};

        if (!this.display.judgeData.runs)
            this.display.judgeData.runs = [];

        this.display.judgeData.runs.push(run);

        this.judgeService.getScoresForRun(run.id, this.display.classes[run.rodeoEventScheduleId].id)
        .then(judgeConfig => {
            judgeConfig.categories.forEach(category => {

                judgeConfig.judges.forEach(judge => {
                    const judgeIndex = judgeConfig.judges.indexOf(judge);

                    if (!this.scores)
                        this.scores = [];

                    if (!this.scores[judgeIndex])
                        this.scores[judgeIndex] = [];

                    if (!this.scores[judgeIndex][category.id])
                        this.scores[judgeIndex][category.id] = [];

                    this.scores[judgeIndex][category.id][run.id] = 0;

                    judge.scores.forEach(score => {
                        const category = judgeConfig.categories.find(x => x.category.trim() === score.category.trim());

                        if (!this.scores[judgeIndex][category.id])
                            this.scores[judgeIndex][category.id] = [];

                        this.scores[judgeIndex][category.id][score.runId] = score.score;
                    });
                });
            });

            this.display.judgeData.scores[run.id] = judgeConfig;
            this.display.judgeData.errors[run.id] = null;
        })
        .catch(err => {
            console.log("err: ", err);
            this.display.judgeData.errors[run.id] = "Could not retrieve scores";
        })
    }

    getHorseAge(birthDate) {
        const birthdate = new Date(birthDate);
        const today = new Date();
        const diffYear = today.getFullYear() - birthdate.getFullYear();
        const diffMonths = today.getMonth() - birthdate.getMonth();
        return `${diffYear}y ${diffMonths}m`;
    }
    
    download() {
        const report = [];
        const rodeoEvents = this.rodeo.rodeoEvents;
        rodeoEvents.forEach((rodeoEvent: any) => {
            if (rodeoEvent.runs) {
                rodeoEvent.runs.forEach(run => {
                    report.push(this.createReportItem(rodeoEvent, run, run.contestantOne, run.horseOne));
                    if (rodeoEvent.eventType == 'TeamRoping' || rodeoEvent.eventType == 'ShowTeamRoping') {
                        report.push(this.createReportItem(rodeoEvent, run, run.contestantTwo, run.horseTwo, 2));
                    }
                });
            }
        });
        this.reportService.exportToCsv(report, `${this.rodeo.name} - ${this.schedule.name}`);
    }

    private createReportItem(rodeoEvent, run, contestant, horse, horseNum = 1) {
        let item = {
            "Rodeo Event": `${rodeoEvent.displayName} - ${this.schedule.name} ${this.datePipe.transform(this.dateHelper.formatDateToSelectedTimeZone(this.schedule.scheduledDate, this.rodeo.rodeoTimezone), 'EE M/d h:mm a')}`,
            Run: run.number,
            Contestant: contestant ? `${contestant.firstName} ${contestant.lastName}` : '',
            City: contestant ? contestant.city : '',
            State: contestant ? contestant.state : ''
        } as any;

        const isRoughStock = this.isRoughStock(rodeoEvent);
        if (!isRoughStock) {
            item["Horse"] = horse ? horse.name : 'Horse ' + horseNum;
            item["Horse AQHA Id"] = horse ? horse.aqhaId : '';
            item["Horse Age"] = horse && horse.birthDate ? this.getHorseAge(horse.birthDate) : '';
            item["Horse Sex"] = horse ? horse.sex : '';
            item["Horse Sire"] = horse && horse.sire ? horse.sire.name : '';
            item["Horse Dam"] = horse && horse.dam ? horse.dam.name : '';
            item["Horse Dam Sire"] = horse && horse.dam && horse.dam.sire ? horse.dam.sire.name : '';
            item["Horse Owner"] = horse && horse.owner ? horse.owner.name : '';
            item["Horse Breeder"] = horse && horse.breeder ? horse.breeder.name : '';
            item["TO"] = run.turnedOut ? 'X' : '';
            item["Time"] = run.turnedOut ? 'TO' : run.time;
        }


        if (isRoughStock) {
            item["Stock #"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Ride"] = run.turnedOut ? 'TO' : run.score;
            item["Stock"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Subtotal"] = run.time
            item["Total"] = run.totaltime
        } else if (rodeoEvent.eventType !== 'BarrelRacing') {
            item["Stock"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Penalty"] = run.penaltyTime;
            item["Total Time"] = run.totalTime;
        }

        return item;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-individual-show.ts